(() => {
  const NAVIGATION_VERSION = '2026-08-11-gender-aware-collection-navigation-v3';
  const COLLECTIONS_TITLE = 'COLLECTIONS';

  const mensItems = [
    { label: 'New Arrivals', handle: 'latest-drop' },
    { label: 'Denim', handle: 'made-to-order-denim' },
    { label: 'Outerwear', handle: 'outerwear' },
    { label: 'T-Shirts', handle: 'tshirts' },
    { label: 'Tracksuits', handle: 'tracksuits' },
    { label: 'Ottoman', handle: 'ottoman-collection' },
    { label: 'One-of-One', handle: 'one-of-one-pieces' },
    { label: 'Accessories', handle: 'accessories' },
    { label: 'Sale', handle: 'sale', sale: true },
    { label: 'Womens', handle: 'all-womens' }
  ];

  const womensHandles = new Set([
    'all-womens',
    'new-womens-arrivals',
    'embellished-collection',
    'made-to-order-womens',
    'militia-collection',
    'one-of-one-capris-womens',
    'one-of-one-denim-womens',
    'one-of-one-tops',
    'ready-to-ship-womens',
    'thrasher-denim-womens',
    'waxed-denim',
    'western-stud-denim'
  ]);

  const womensLabelOverrides = {
    'made-to-order-womens': 'Made to Order Denim',
    'one-of-one-denim-womens': 'One-of-One Vintage Denim',
    'one-of-one-tops': 'One-of-One Tops',
    'waxed-denim': 'Waxed Denim',
    'militia-collection': 'Militia Collection',
    'embellished-collection': 'Embellished Collection'
  };

  const normalize = (value) => value.replace(/\s+/g, ' ').trim().toUpperCase();

  const getCurrentCollectionHandle = () => {
    const match = window.location.pathname.match(/\/collections\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  };

  const getHandleFromHref = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/collections\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]).toLowerCase() : '';
    } catch (error) {
      return '';
    }
  };

  const isCurrentCollection = (handle) => getCurrentCollectionHandle() === handle.toLowerCase();
  const isWomensCollection = () => womensHandles.has(getCurrentCollectionHandle());

  const createLink = ({ label, handle, sale = false }) => {
    const active = isCurrentCollection(handle);
    const link = document.createElement('a');
    const classes = ['facet-collection-link', 'jeanius-collection-navigation__link'];

    if (sale) {
      classes.push('jeanius-collection-navigation__link--sale', 'jeanius-sale-link');
    }

    if (active) {
      classes.push('active');
    }

    link.href = `/collections/${handle}`;
    link.className = classes.join(' ');
    link.textContent = label;

    if (active) {
      link.setAttribute('aria-current', 'page');
    }

    return link;
  };

  const createNavigation = () => {
    const navigation = document.createElement('nav');
    navigation.className = 'jeanius-collection-navigation';
    navigation.dataset.jeaniusNavigationVersion = NAVIGATION_VERSION;
    navigation.setAttribute('aria-label', 'Shop collections');

    mensItems.forEach((item) => navigation.appendChild(createLink(item)));

    return navigation;
  };

  const createNavigationFromAccordion = (accordion) => {
    const navigation = document.createElement('nav');
    navigation.className = 'jeanius-collection-navigation jeanius-collection-navigation--womens';
    navigation.dataset.jeaniusNavigationVersion = NAVIGATION_VERSION;
    navigation.setAttribute('aria-label', 'Shop womens collections');

    accordion.querySelectorAll('.facet-collection-link').forEach((sourceLink) => {
      const link = sourceLink.cloneNode(true);
      const handle = getHandleFromHref(link.href);
      link.classList.add('jeanius-collection-navigation__link');

      if (womensLabelOverrides[handle]) {
        link.textContent = womensLabelOverrides[handle];
      }

      if (normalize(link.textContent) === 'SALE') {
        link.classList.add('jeanius-collection-navigation__link--sale', 'jeanius-sale-link');
      }

      navigation.appendChild(link);
    });

    return navigation;
  };

  const injectStyles = () => {
    let style = document.getElementById('jeanius-collection-navigation-styles');

    if (!style) {
      style = document.createElement('style');
      style.id = 'jeanius-collection-navigation-styles';
      document.head.appendChild(style);
    }

    style.textContent = `
      .jeanius-collection-navigation {
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 0 !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 0 1.2rem !important;
        border-bottom: 0 !important;
      }

      .jeanius-collection-navigation .jeanius-collection-navigation__link {
        display: block !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        color: #000 !important;
        opacity: 1 !important;
        font-family: var(--font-header-menu-family) !important;
        font-style: var(--font-header-menu-style) !important;
        font-weight: var(--font-header-menu-weight) !important;
        font-variation-settings: normal !important;
        font-size: calc(var(--font-header-menu-text-scale) * 1rem) !important;
        line-height: 1.5 !important;
        letter-spacing: var(--font-header-menu-letter-spacing) !important;
        text-transform: var(--font-header-menu-text-transform) !important;
        text-align: left !important;
        text-decoration: none !important;
        -webkit-text-stroke: 0 !important;
      }

      .jeanius-collection-navigation .jeanius-collection-navigation__link.active {
        color: #000 !important;
        opacity: 1 !important;
        font-style: normal !important;
        font-weight: 700 !important;
        font-variation-settings: "wght" 700 !important;
        font-synthesis: weight !important;
        -webkit-text-stroke: 0 !important;
      }

      @media screen and (hover: hover) and (pointer: fine) {
        .jeanius-collection-navigation .jeanius-collection-navigation__link:hover {
          color: #000 !important;
          opacity: 1 !important;
          font-style: normal !important;
          font-weight: 700 !important;
          font-variation-settings: "wght" 700 !important;
          font-synthesis: weight !important;
          -webkit-text-stroke: 0 !important;
        }
      }

      a.jeanius-sale-link,
      a.jeanius-sale-link *,
      a.jeanius-sale-link:hover,
      a.jeanius-sale-link:hover *,
      .jeanius-collection-navigation .jeanius-collection-navigation__link--sale,
      .jeanius-collection-navigation .jeanius-collection-navigation__link--sale.active,
      .jeanius-collection-navigation .jeanius-collection-navigation__link--sale:hover {
        color: #ff0000 !important;
        opacity: 1 !important;
      }

      @media screen and (min-width: 769px) {
        .collection-section .facets-container {
          position: relative !important;
          top: auto !important;
          align-self: stretch !important;
          height: auto !important;
          min-height: 0 !important;
          overflow: visible !important;
        }

        .collection-section .facets-container > .facets__form {
          position: sticky !important;
          top: calc(var(--header-height, 0px) + 5.6rem) !important;
          max-height: calc(100vh - var(--header-height, 0px) - 7.2rem) !important;
          overflow-y: auto !important;
          scrollbar-width: none;
          z-index: 3 !important;
        }

        .collection-section .facets-container > .facets__form::-webkit-scrollbar {
          display: none;
        }
      }
    `;
  };

  const replaceCollectionNavigation = (root = document) => {
    if (!root.querySelectorAll) return;

    const accordions = [];

    if (root.matches && root.matches('.facet-accordion')) {
      accordions.push(root);
    }

    root.querySelectorAll('.facet-accordion').forEach((accordion) => {
      accordions.push(accordion);
    });

    accordions.forEach((accordion) => {
      const title = accordion.querySelector('.facet-accordion__title');

      if (!title || normalize(title.textContent) !== COLLECTIONS_TITLE) return;

      const navigation = isWomensCollection()
        ? createNavigationFromAccordion(accordion)
        : createNavigation();

      accordion.replaceWith(navigation);
    });
  };

  const markSaleLinks = (root = document) => {
    const saleLinks = [];

    if (root.matches && root.matches('a[href*="/collections/sale"]')) {
      saleLinks.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('a[href*="/collections/sale"]').forEach((link) => {
        saleLinks.push(link);
      });
    }

    saleLinks.forEach((link) => {
      if (normalize(link.textContent) === 'SALE') {
        link.classList.add('jeanius-sale-link');
      }
    });
  };

  let updateQueued = false;

  const scheduleUpdate = (root = document) => {
    if (updateQueued) return;
    updateQueued = true;

    window.requestAnimationFrame(() => {
      injectStyles();
      replaceCollectionNavigation(root);
      markSaleLinks(root);
      updateQueued = false;
    });
  };

  const initialise = () => scheduleUpdate(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => {
    scheduleUpdate(event.target);
  });

  const observer = new MutationObserver((mutations) => {
    const addedElement = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) => node.nodeType === 1)
    );

    if (addedElement) {
      scheduleUpdate(document);
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
